"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	AccountActions: require("./AccountActions"),
	AccountAddressTypeSelector: require("./AccountAddressTypeSelector"),
	AccountEmailTypeSelector: require("./AccountEmailTypeSelector"),
	AccountMediaSelector: require("./AccountMediaSelector"),
	AccountPhoneTypeSelector: require("./AccountPhoneTypeSelector"),
	AccountStore: require("./AccountStore"),
	AccountTitleSelector: require("./AccountTitleSelector"),
	BillingAddressHelper: require("./BillingAddressHelper"),
	ChildCommunicationsHelper: require("./ChildCommunicationsHelper"),
	CountrySelector: require("./CountrySelector"),
	CreditCardHelper: require("../commonComponents/CreditCardHelper"),
	DefaultBillingAndShippingAddressHelper: require("./DefaultBillingAndShippingAddressHelper"),
	EventSearchActions: require("../actions/EventSearchActions"),
	EventSearchStore: require("../stores/EventSearchStore"),
	GivingStatementHelper: require("./GivingStatementHelper"),
	MyPledgesEditFrequencySelector: require("./MyPledgesEditFrequencySelector"),
	MyPledgesHelper: require("./MyPledgesHelper"),
	MyRecurringHeaderEditFrequencySelector: require("./MyRecurringHeaderEditFrequencySelector"),
	MyRecurringHeaderEditUseOnDaySelector: require("./MyRecurringHeaderEditUseOnDaySelector"),
	MyRecurringHelper: require("./MyRecurringHelper"),
	MySponsorshipsEditFrequencySelector: require("./MySponsorshipsEditFrequencySelector"),
	MySponsorshipsHelper: require("./MySponsorshipsHelper"),
	MySubscriptionsHelper: require("./MySubscriptionsHelper"),
	OrganizationContactTypeSelector: require("./OrganizationContactTypeSelector"),
	OrganizationTypeSelector: require("./OrganizationTypeSelector"),
	OtherAddressesHelper: require("./OtherAddressesHelper"),
	PaymentTypeSelector: require("../checkoutComponents/PaymentTypeSelector"),
	SmartyStreets: require("./SmartyStreets"),
	StateSelector: require("./StateSelector"),
	SubscriptionHelper: require("../subscriptionComponents/SubscriptionHelper") //Here because the _SubscriptionsLayout.cshtml loads it already.
};
